import React, { Component } from "react"
import PropTypes from "prop-types"
import Draggable from "react-draggable"
import { Tabs, Tab } from "material-ui/Tabs"
import { pinkA200, blueGrey600 } from "material-ui/styles/colors"
import IconButton from "material-ui/IconButton"
import ActionExpandLess from "material-ui/svg-icons/navigation/expand-less"
import ActionExpandMore from "material-ui/svg-icons/navigation/expand-more"
import ActionDragHandle from "material-ui/svg-icons/editor/drag-handle"
import styled from "styled-components"
import { connect } from "../utils"
import BodyItem from "./BodyItem"
import RowItem from "./RowItem"
import ContentItem from "./ContentItem"
import TemplateItem from "./TemplateItem"

import "../editor/index.css"

class CatalogDrag extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: "Row",
      isOpen: false,
      isHidden: false,
      clientY: 0,
      controlledPosition: {
        x: 0,
        y: 0,
      },
    }
    this.onControlledDrag = this.onControlledDrag.bind(this)
  }
  handleChange = (value) => {
    this.setState({
      value: value,
      isOpen: true,
    })
  }
  onControlledDrag(e, position) {
    const { x, y } = position
    this.setState({ controlledPosition: { x, y } })
  }
  onUpdateData = (data) => {
    try {
      this.props.layoutState.updateItem("root")(["props"], () => data)
    } catch (err) {
      console.log(err.message)
    }
  }

  onUpdateTemplate = (data) => {
    try {
      this.props.layoutState.setItems(data)
    } catch (err) {
      console.log(err.message)
    }
  }

  renderComponent(tab) {
    const { components } = this.props
    const styles = getStylesContent()
    const stylesContent =
      tab === "Content" ? styles.sidebarOpen : styles.sidebarOpenRow
    const isOPen = this.state.isOpen ? stylesContent : styles.sidebarClosed

    return (
      <Tab label={tab} value={tab}>
        <div style={isOPen}>
          {Object.keys(components).map((key) => {
            let obj = Object.hasOwnProperty.call(
              components[key],
              "defaultProps"
            )
            if (obj) {
              let { value } = Object.getOwnPropertyDescriptor(
                components[key],
                "defaultProps"
              )
              if (tab === "Row") {
                if (value.childOf === tab) {
                  return (
                    <RowItem
                      key={key}
                      type={key}
                      component={components[key]}
                      defaultProps={value}
                    />
                  )
                }
              } else {
                if (value.childOf === tab) {
                  return (
                    <ContentItem
                      key={key}
                      type={key}
                      component={components[key]}
                      defaultProps={value}
                    />
                  )
                }
              }
            }
            return <div key={key} />
          })}
        </div>
      </Tab>
    )
  }
  onShowTab = () => {
    this.setState({
      isOpen: !this.state.isOpen,
      isHidden: false,
    })
  }
  render() {
    const dataBody = this.props.layoutState.getItemJS("root").props
    const styles = getHeightStyle()
    const isOPen = this.state.isOpen ? styles.sidebarOpen : styles.sidebarClosed
    const iconAction = this.state.isOpen ? (
      <ActionExpandLess />
    ) : (
      <ActionExpandMore />
    )
    const hidden = this.state.isHidden ? { width: 0 } : { width: 320 }
    return (
      <Draggable
        handle="strong"
        position={this.state.controlledPosition}
        onDrag={this.onControlledDrag}
      >
        <DivContainer
          style={{
            position: "fixed",
            zIndex: 1100,
            top: 0,
            right: 12,
          }}
        >
          <DragButton>
            <strong>
              <IconButton
                style={{ cursor: "move" }}
                hoveredStyle={{ cursor: "move" }}
                iconStyle={{
                  color: "#FFFFFF",
                }}
              >
                <ActionDragHandle />
              </IconButton>
            </strong>
          </DragButton>
          <DivButton>
            <IconButton
              iconStyle={{
                color: "#FFFFFF",
              }}
              onClick={this.onShowTab.bind()}
            >
              {iconAction}
            </IconButton>
          </DivButton>
          <BoxTabs style={hidden}>
            <Tabs value={this.state.value} onChange={this.handleChange}>
              {this.renderComponent("Row")} {this.renderComponent("Content")}
              <Tab label="Body" value="Body">
                <div style={isOPen}>
                  <BodyItem
                    data={dataBody}
                    onUpdateData={(data) => this.onUpdateData(data)}
                  />
                </div>
              </Tab>
              {this.props.statusForm && this.props.statusForm === "create" && (
                <Tab label="Template" value="Template">
                  <div style={isOPen}>
                    <TemplateItem
                      onUpdateData={(data) => this.onUpdateTemplate(data)}
                    />
                  </div>
                </Tab>
              )}
            </Tabs>
          </BoxTabs>
        </DivContainer>
      </Draggable>
    )
  }
}

const getStylesContent = () => {
  // const width = "300px";
  return {
    sidebarOpen: {
      maxHeight: 555,
      width: "100%",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      overflowY: "scroll",
      paddingLeft: 10,
      display: "flex",
      transition: "max-height 0.35s ease-in",
      zIndex: 402,
    },
    sidebarOpenRow: {
      maxHeight: 555,
      width: "100%",
      flexDirection: "column",
      display: "flex",
      transition: "max-height 0.35s ease-in",
      zIndex: 402,
    },
    sidebarClosed: {
      maxHeight: 0,
      width: 0,
      overFlow: "hidden",
      display: "none",
      transition: "max-height 0.35s ease-out",
      zIndex: 402,
    },
  }
}

const getHeightStyle = () => {
  return {
    sidebarOpen: {
      maxHeight: 555,
      width: "100%",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      overflowY: "scroll",
      display: "flex",
      transition: " max-height 0.35s ease-in",
      zIndex: 402,
    },
    sidebarClosed: {
      maxHeight: 0,
      width: 0,
      overFlow: "hidden",
      display: "none",
      transition: "max-height 0.35s ease-out",
      zIndex: 402,
    },
  }
}

const DivContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 400px;
  z-index: 402;
`
const DivButton = styled.div`
  z-index: 402;
  margin-left: 0px;
  height: 48px;
  background-color: ${pinkA200};
`
const DragButton = styled.div`
  z-index: 402;
  margin-left: 0px;
  height: 48px;
  background-color: ${blueGrey600};
`
const BoxTabs = styled.div`
  background-color: #ffffff;
  height: 100%;
`
CatalogDrag.propTypes = {
  components: PropTypes.object.isRequired,
  layoutState: PropTypes.object,
}

export default connect("components")(CatalogDrag)



// WEBPACK FOOTER //
// ./src/editor/layout/catalog/CatalogDrag.js